<template>
  <div class="app-all-events">
    <AlertBar />
    <BannerTitle :title="pageTitle" />

    <section class="pt-10 pb-8 lightGrey">
      <AdvancedSearchContainer
        @toggle-advanced-search-form="toggleAdvancedSearchForm()"
        :advanced-search-active="advancedSearchActive"
        :filter-context="filterContext"
        :is-fluid="!this.lgBreakpoint"
      />
    </section>

    <section class="py-12">
      <v-container :fluid="!this.lgBreakpoint">
        <v-row align="center" class="flex-column">
          <v-col cols="12">
            <AllEventsActiveSearchFilters />
            <AllEventsTable
              :table-data="TABLE_DATA"
              :rows-per-page="RESULTS_PER_PAGE"
            />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations,mapState } from 'vuex';

import AlertBar from '@/components/AlertBar.vue';
import BannerTitle from '@/components/BannerTitle.vue';
import AllEventsActiveSearchFilters from '@/components/Search/AllEventsActiveSearchFilters';
import AllEventsTable from '@/components/AllEventsTable';
import AdvancedSearchContainer from '@/components/Search/AdvancedSearchContainer.vue';

export default {
  name: 'AllEvents',
  components: {
    AdvancedSearchContainer,
    AlertBar,
    AllEventsTable,
    BannerTitle,
    AllEventsActiveSearchFilters
  },
  data() {
    return {
      advancedSearchActive: false,
      filterContext: 'allEvents',
      rowsPerPageOptions: [
        {
          text: '25',
          value: 25
        },
        {
          text: '50',
          value: 50
        },
        {
          text: '100',
          value: 100
        }
      ]
    };
  },
  async created() {
    this.SET_PROXY(false);
    await this.GET_EVENTS({ context: this.filterContext });
  },
  beforeDestroy() {
    this.SET_PROXY(true);
  },
  computed: {
    ...mapState('EVENT_TABLE_STORE', [
      'TABLE_DATA',
      'LOADING',
      'RESULTS_PER_PAGE'
    ]),
    lgBreakpoint: function() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    pageTitle() {
      return this.$route.path.includes('/event/reporting') ? 'All Events Reporting' : 'All Events';
    }
  },
  methods: {
    ...mapActions('EVENT_TABLE_STORE', ['GET_EVENTS', 'CHANGE_ITEMS_PER_PAGE']),
    ...mapMutations('EVENT_TABLE_STORE', ['SET_PROXY']),

    next(page) {
      this.$store.commit('EVENT_TABLE_STORE/SET_CURRENT_PAGE', page);
    },
    toggleAdvancedSearchForm() {
      this.advancedSearchActive = !this.advancedSearchActive;
      if (
        !document
          .getElementsByClassName('app-events-advanced-search')[0]
          .classList.contains('active')
      ) {
        document
          .getElementsByClassName('app-events-advanced-search')[0]
          .classList.add('active');
        document
          .getElementsByClassName('app-all-events__showsearch')[0]
          .getElementsByTagName('span')[0].innerHTML = 'Hide Advanced Search';
      } else {
        document
          .getElementsByClassName('app-events-advanced-search')[0]
          .classList.remove('active');
        document
          .getElementsByClassName('app-all-events__showsearch')[0]
          .getElementsByTagName('span')[0].innerHTML = 'Show Advanced Search';
      }
    }
  }
};
</script>

<style scoped lang="scss">
// .container--fluid {
//   // max-width: 1200px;
// }
.app-all-events__pagination-wrap {
  display: flex;
  justify-content: space-between;
}
.app-all-events__itemsperpage {
  display: flex;
  margin-top: 32px;
}
.app-all-events__itemsperpage a {
  text-decoration: none;
  font-weight: 700;
  color: #000;
  margin-left: 5px;
  margin-right: 5px;
}
.app-all-events__itemsperpage a.active {
  color: var(--v-primary-base);
}
.app-all-events__showsearch > a {
  text-decoration: none;
  color: #000;
  font-weight: 700;
}
.v-pagination {
  align-items: flex-start !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 48px;
}
</style>
